import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import {
  LoaderOverlayComponent,
  OverlayType,
} from '../loader-overlay/loader-overlay.component';

@Injectable()
export class LoaderOverlayService {
  private openSubject = new Subject<void>();
  private closeSubject = new Subject<void>();

  private component: null | LoaderOverlayComponent;
  private overlayRef: OverlayRef;
  private portal: ComponentPortal<LoaderOverlayComponent>;

  get opened$() {
    return this.openSubject.asObservable();
  }

  get closed$() {
    return this.closeSubject.asObservable();
  }

  /** Dependencies */
  constructor(private overlay: Overlay) {}

  public open() {
    this.detach();

    this.createOverlay();
    this.portal = this.portal || new ComponentPortal(LoaderOverlayComponent);

    this.component = this.overlayRef.attach(this.portal).instance;
    this.component.type = OverlayType.FIXED;

    this.openSubject.next();
  }

  private createOverlay() {
    const positionStrategy = this.overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically();

    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      positionStrategy,
    });
  }

  public close() {
    this.closeSubject.next();
    this.detach();
  }

  private detach() {
    if (this.overlayRef && this.overlayRef.hasAttached()) {
      this.overlayRef.detach();
    }

    this.component = null;
  }
}
